import { memo, useState } from "react";
import "./header.scss";

import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import { useAuth } from "../../contexts/AuthContext";
import logoIcon from "../../assets/images/logo-icon.ico";

const AvatarIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor">
    <path d="M16 8a5 5 0 110 10 5 5 0 010-10zm0 12c5.5 0 10 2.5 10 5v2H6v-2c0-2.5 4.5-5 10-5z" />
  </svg>
);

const Header = () => {
  const { logout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const navigateToLogout = () => {
    sessionStorage.clear();
    logout();
  };

  return (
    <header className="header">
      {/* Left: Logo */}
      <div className="header__logo">
        <img src={logoIcon} alt="Hotel Trader" />
      </div>

      {/* Spacer pushes the next cluster to the right */}
      <div className="header__spacer" />

      <div className="header__right">
        <Dropdown
          className="dropdown-main"
          isOpen={dropdownOpen}
          toggle={() => setDropdownOpen(!dropdownOpen)}
          direction="down"
        >
          <DropdownToggle
            tag="button"
            className="avatar-dropdown-toggle"
            data-testid="avatar-dropdown-toggle"
          >
            <span className="avatar-fallback">
              <AvatarIcon />
            </span>
          </DropdownToggle>

          <DropdownMenu>
            <DropdownItem>
              <div className="dropdown-option" onClick={navigateToLogout}>
                <i className="fa fa-sign-out" />
                Sign Out
              </div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </header>
  );
};

export default memo(Header);
